import { useRef } from "react";
import { FileIcon } from "../../assets/icons";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import imageCompression from "browser-image-compression";

export default function FileInput({ callbackFunc }) {
  const maxUploadSize = import.meta.env.VITE_MAX_FILE_UPLOAD_SIZE;
  const allowedImgMimes = import.meta.env.VITE_IMG_UPLOAD_MIME;
  const maxFileSize = parseInt(maxUploadSize) * 1024 * 1024;

  const { t } = useTranslation();

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const arrmgMimes = allowedImgMimes.split(",");

      if (!arrmgMimes.includes(file.type)) {
        toast.error(
          t("validation.img_upload_mime", { formats: imageTypeTexts() })
        );
      } else if (file.size > maxFileSize) {
        toast.error(
          t("validation.max_img_upload_size", { max: maxUploadSize })
        );
      } else {
        if (file.size >= 5 * 1024 * 1024) {
          const compressed = await imageCompression(file, {
            maxSizeMB: 5,
            maxWidthOrHeight: 1800,
            useWebWorker: true,
          });

          const compressedFile = new File([compressed], file.name, {
            type: compressed.type,
          });

          callbackFunc(compressedFile);
        } else {
          callbackFunc(file);
        }
      }
    }
  };

  const imageTypeTexts = () => {
    const arrmgMimes = allowedImgMimes.split(",");
    let mimes = [];
    for (const mime of arrmgMimes) {
      let arr = mime.split("/");
      mimes.push(arr.at(-1));
    }
    return mimes.join(",");
  };

  return (
    <>
      <button
        type="button"
        onClick={handleButtonClick}
        title={t("buttons.titles.chose_img")}
      >
        <FileIcon className="text-blue-500 size-6 dark:text-white/90" />
      </button>
      <input
        type="file"
        ref={fileInputRef}
        accept={allowedImgMimes}
        onChange={handleFileChange}
        className="hidden"
      />
    </>
  );
}
